<p (click)="handleAddToWishlist()" *ngIf="toUserUUID && !connectionItem && !loader" class="cursor-pointer w-fit mb-0 wishlit-btn-para"
  ngbTooltip="Save for later">
  <a class="w-100 btn btn-lg btn-white text-primary ls-2 fs-6 d-flex align-items-center no-wrap px-4">
    <i class="bi bi-bookmark fs-4 text-primary"></i>
    Save
  </a>
</p>

<p (click)="handleRemoveFromWishlist()" *ngIf="connectionItem && !loader" class="cursor-pointer w-fit mb-0 wishlit-btn-para"
  ngbTooltip="Remove from saved list">
  <a class="w-100 btn btn-lg btn-white text-primary ls-2 fs-6 d-flex align-items-center no-wrap px-4">
    <i class="bi bi-bookmark-fill fs-4 text-primary"></i>
    <span class="saved-text">Saved</span>
    <span class="remove-text">Remove</span>
  </a>
</p>

<span class="indicator-progress" [class.d-inline-block]="loader">
  <span class="spinner-border spinner-border-sm align-middle ms-2">
  </span>
</span>
